module.exports = __webpack_public_path__ + "img/ideias-e-acoes.570595d3.jpg";